var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 416,
    viewBox: "0 0 352 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 48C80 30.3269 94.3264 16 112 16H124.226C133 6.19696 145.771 0 160 0C174.229 0 187 6.19696 195.774 16H208C225.674 16 240 30.3269 240 48H272C298.51 48 320 69.4904 320 96V176C320 184.837 312.837 192 304 192C295.163 192 288 184.837 288 176V96C288 87.1635 280.837 80 272 80H240C240 97.6731 225.674 112 208 112H112C94.3264 112 80 97.6731 80 80H48C39.1635 80 32 87.1635 32 96V352C32 360.837 39.1635 368 48 368H112C120.837 368 128 375.163 128 384C128 392.837 120.837 400 112 400H48C21.4904 400 0 378.51 0 352V96C0 69.4904 21.4904 48 48 48H80ZM146.131 40.0117C148.922 35.1875 154.098 32 160 32C165.902 32 171.078 35.1875 173.869 40.0117L178.49 48H208V80H112V48H141.51L146.131 40.0117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.313 283.314C305.561 277.066 305.561 266.934 299.313 260.686C293.065 254.438 282.934 254.438 276.686 260.686L224 313.373L203.313 292.686C197.065 286.438 186.934 286.438 180.686 292.686C174.438 298.934 174.438 309.066 180.686 315.314L212.686 347.314C218.934 353.562 229.065 353.562 235.313 347.314L299.313 283.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 304C128 242.144 178.144 192 240 192C301.856 192 352 242.144 352 304C352 365.856 301.856 416 240 416C178.144 416 128 365.856 128 304ZM240 224C195.818 224 160 259.818 160 304C160 348.182 195.818 384 240 384C284.182 384 320 348.182 320 304C320 259.818 284.182 224 240 224Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 416,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.71d37024ec8b150f1f8908a490333178.svg";
export { ForwardRef as ReactComponent };